<script>
  import { onMount } from 'svelte';

  import { fly } from "svelte/transition";

  import { circOut as ease } from "svelte/easing";

  import Slider from '@bulatdashiev/svelte-slider';

  export let config = {};
  export let items = [];

  let lastActiveIndex;
  let activeIndex = 0;

  let sliderValues = [3,3]; // slidervalues is an array of [min,max]. If Slider is not of type RANGE, both values are identical.
  $: on_slidervalues_change = sliderValues
  $: on_slidervalues_change, updateActiveIndex()
  function updateActiveIndex(){
    activeIndex = sliderValues[0];
  }

  let sliderW;

  $: sliderSteps = items.length-1;
  $: thumb = config.thumb || '';

  let demoIndex;

  onMount(async () => {
    // force update. without, slider images are stuck on NaN upon load
		// sliderValues = sliderValues;
		sliderValues = [3,3];
	});

  // When creating vars using $:, you can only use them in other variables assigned using $:.
  // https://stackoverflow.com/a/56318461/2619245
  //
  // watch changes in activeIndex
  $: on_active_change = activeIndex
  // handle changes
  $: on_active_change, updateSlideVisibility()

  function updateSlideVisibility(){
    items.forEach( (item, i) => {
      items[i].active = i === activeIndex
    });

    // trigger update after changes _inside_ array
    // https://svelte.dev/tutorial/updating-arrays-and-objects
    items = items;
  }


  function active( index ){
    lastActiveIndex = activeIndex

    let newActive
    // unflipping card, result: no flipped cards
    if( index == activeIndex ) newActive = -1
    // switching between cards
    else newActive = index

    activeIndex = newActive
  }


  let demoTimeout;
  let demoInterval;

  initDemoMode()

  function initDemoMode(){
    demoTimeout = setTimeout(startDemoMode, 9000)
  }

  function startDemoMode(){
    demoInterval = setInterval(setDemoIndex, 5000)
  }

  function setDemoIndex(){
    if (activeIndex >= 0) return;

    let newDemoIndex = Math.round( Math.random() * (items.length-1) );
    if (demoIndex == newDemoIndex) {
      setDemoIndex()
    } else {
      demoIndex = newDemoIndex
    }
  }

  function stopDemoMode( eventName ){
    // console.log( 'stopDemoMode', eventName )
    clearTimeout(demoTimeout)
    clearInterval(demoInterval)
    demoIndex = -1
    initDemoMode();
  }

  function getSliderStepFromClickX(event){
    let clickX = event.clientX;
    let clickXPercent = clickX/sliderW;
    let sliderStep = Math.round((items.length-1) * clickXPercent);
    // console.log('handleSliderClick', event, ' cX:', clickX, ' slW:', sliderW, ' cXP:', clickXPercent, ' step:', step);
    sliderValues = [sliderStep,sliderStep];
  }

</script>


<ol
  class="content"
  class:active={ activeIndex > -1 }
  on:mousemove={ ()=>{stopDemoMode('mousemove')} }
  on:click={ ()=>{stopDemoMode('click')} }
  >
  <!-- {#each data as item, i} -->
  {#each items as { headline, copy, image }, i}
    <li 
      in:fly="{{ y:70, duration:500, delay:i*50, easing:ease }}"
      class:active = { i === activeIndex }
      class:lastActive = { i === lastActiveIndex }
    >
      <!-- {#if headline}<p>{ @html headline }</p>{/if}
      {#if copy}<h2>{ @html copy }</h2>{/if} -->
      {#if image}<img alt="" src="{image}">{/if}
    </li>
  {/each}
</ol>
<ol class="labels">
  {#each items as { headline }, i}
    <li 
      class:active = { i === activeIndex }
      on:click={ ()=>{ sliderValues=[i,i] } }
    >
      {#if headline}<h3>{ @html headline }</h3>{/if}
    </li>
  {/each}
</ol>


<div class="slider-container"
  on:click={ (event)=>{getSliderStepFromClickX(event)} }
  bind:clientWidth={sliderW}
>
  <Slider 
    bind:value={sliderValues}
    min="0"
    max="{sliderSteps}"
    step="1"
  >
    <span
      class="slider-thumb"
      class:default = { thumb === '' }
      class:custom = { thumb !== '' }
    >
      {thumb}
    </span>
  </Slider>
</div>

<!-- https://lizenzhinweisgenerator.de -->
<cite>
  {#if items[activeIndex]}
    {@html items[activeIndex].credit}
  {/if}
</cite>


<style>
  li:before,
  li:after {
    content: '';
    display: none;
  }

  ol {
    list-style-type: none;
    padding: 0;
    margin: 0.5rem;
    position: relative; /* needed for fullsize card backs*/
  }
/* 
  @media (min-width: 33em){
    ol {
      position: relative;
    }
  } */

  ol.content {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }

  ol.content li {
    grid: 1;
    grid-column-start: 1;
    grid-row-start: 1;
    visibility:hidden;
  }

  ol.content li.active {
    visibility: visible;
  }

  ol.content img {
    width: 100%;
  }


  ol.labels {
    display: grid;
    column-gap: 3%;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
  }

  ol.labels li {
    opacity: 0.3;
    /* background: var(--color-blue-light-4); */
    cursor: pointer;
  }

  ol.labels li h3 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  :global(ol.labels li h3 small) {
    font-weight: normal;
    white-space: nowrap;
  }

  ol.labels li.lastActive {
    z-index: 5;
  }
  ol.labels li.active {
    z-index: 10;
    opacity: 1;
  }

  h2,
  h3{
    margin-top: 0; /* list and card margin/padding are sufficient, no additional space for first headline */
  }

  .copy {
    margin-top: 1.4em; /* line-height, essentialy looks an empty line */
  }

  .slider-container {
    --track-bg: var(--color-blue-light-3);
    --progress-bg: var(--color-blue-dark);
    --thumb-bg: var(--color-blue-light-2);
    --thumb-fg: var(--color-blue-dark);

    padding: 0.1px 3%; /* pad-x has to be non-zero or container will collapse to only slider-track height (withour thumb) */
    margin: 1em 0 2em;
  }

  .slider-thumb.default {
    display: block;
    width: 1em;
    height: 1em;
    background-color: var(--thumb-fg);
    border-radius: 50%;
  }

  .slider-thumb.custom {
    font-size: 30px;
  }
</style>